// Library Imports
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Local Imports
import { isEmailVerifiedAPIFn } from '@/redux/features/MediaKit/mediakitSlice';
import { updateCurrentUser } from '@/redux/features/CurrentUser/currentUserSlice';

export const useEmailVerification = () => {
  const dispatch = useDispatch();
  const userId = useSelector(state => state?.currentUser?.currentUser?.userId);
  
  useEffect(() => {
    if (!userId) return;
    
    const checkEmailVerification = async () => {
      try {
        const res = await dispatch(isEmailVerifiedAPIFn({ userId }));
        if (res?.payload?.message === "True") {
          dispatch(updateCurrentUser({
            isEmailVerified: true
          }));
        }
      } catch (error) {
        console.error('Error checking email verification', error);
      }
    };
    
    checkEmailVerification();
  }, [userId, dispatch]);
};

